import React, { useEffect, useState } from "react";
import { GET_ALL_ADMINS_URL, SEARCH_ADMIN_URL } from "api";
import "datatables.net";
import "datatables.net-responsive";

import $ from "jquery";
import { createAdmin, deleteAdmin, updateAdmin } from "../../../request/admin";
import cogoToast from "cogo-toast";
import { useSelector } from "react-redux";

const Admin = (props) => {
  document.title = "Gari Admins";

  const [loading, setLoading] = useState(false);
  const [editAdmin, setEditAdmin] = useState(false);
  const [adminId, setAdminId] = useState(null);
  const auth = useSelector((state) => state.auth.user);

  useEffect(() => {
    let table = $("#admins").DataTable({
      responsive: true,
      language: {
        processing:
          '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Admin Data</p>',
      },
      searching: true,
      lengthMenu: [[10], [10]],
      ordering: false,
      info: true,
      bFilter: false,
      processing: true,
      pageLength: 10,
      serverSide: true,
      ajax: function (data, callback) {
        $.ajax(
          $(".dataTables_filter input").val().length > 0
            ? SEARCH_ADMIN_URL($(".dataTables_filter input").val())
            : GET_ALL_ADMINS_URL,
          {
            type: "GET",
            data: {
              pageNumber: (data.length + data.start) / data.length,
              pageSize: data.length,
            },
            success: function (res) {
              let result = [];
              res.data.map((data) => {
                result.push({
                  raw: data,
                });
              });

              callback({
                recordsTotal: res.totalRecords,
                recordsFiltered: res.totalRecords,
                data: result,
              });
            },
          }
        );
      },
      columns: [
        { data: "raw" },
        { data: "raw" },
        { data: "raw" },
        { data: "raw" },
        { data: "raw" },
      ],
      columnDefs: [
        {
          render: function (data) {
            return `${data.firstName} ${data.lastName}`;
          },
          targets: 0,
        },
        {
          render: function (data) {
            return data.role;
          },
          targets: 1,
        },
        {
          render: function (data) {
            return data.phoneNumber;
          },
          targets: 2,
        },
        {
          render: function (data) {
            return data.email;
          },
          targets: 3,
        },
        {
          render: function () {
            return `<nav class="nav nav-icon-only">
                    <a href="#" class="nav-link edit_admin"><i class="fa fa-pencil"></i> Edit</a>
                    <a href="#" class="nav-link delete_admin"><i class="fa fa-trash"></i> Delete</a>
                  </nav>`;
          },
          targets: 4,
        },
      ],
    });

    $("#admins").on("click", ".edit_admin", function () {
      $("#modalAdmin").modal({ backdrop: "static", keyboard: false }, "show");
      $("#adminForm").parsley();
      setEditAdmin(true);

      // Enable all form fields
      $(":input", "#adminForm")
        .not(":button, :submit, :reset, :hidden")
        .prop("disabled", false);

      let extract_td = table.row($(this).closest("tr")).data();

      setAdminId(extract_td.raw.id);
      $("#firstName").val(extract_td.raw.firstName);
      $("#lastName").val(extract_td.raw.lastName);
      $("#email").val(extract_td.raw.email);
      $("#phoneNumber").val(extract_td.raw.phoneNumber);
      $("#role").val(extract_td.raw.role);
      $("#address").val(extract_td.raw.physicalAddress);

      return false;
    });

    $("#admins").on("click", ".delete_admin", function () {
      let extract_td = table.row($(this).closest("tr")).data();

      let { hide } = cogoToast.loading("Please wait... contacting to server.", {
        position: "top-right",
        hideAfter: 3,
      });

      deleteAdmin(extract_td.raw.id).then((result) => {
        hide();

        if (!result.error) {
          $("#admins").DataTable().ajax.reload();
          return cogoToast.success("Admin successfully removed", {
            position: "top-right",
            hideAfter: 3,
          });
        }

        cogoToast.error("Failed to delete admin", {
          position: "top-right",
          hideAfter: 3,
        });
      });

      return false;
    });
  }, []);

  const handleShowModal = () => {
    $("#adminForm").parsley();
    $("#password").prop("disabled", false).prop("required", true);
    $("#modalAdmin").modal({ backdrop: "static", keyboard: false }, "show");
    $(":input", "#adminForm")
      .not(":button, :submit, :reset, :hidden")
      .val("")
      .prop("checked", false)
      .prop("selected", false)
      .prop("disabled", false);
  };

  const onSubmitNewAdmin = (e) => {
    e.preventDefault();

    let raw = {
      firstName: $("#firstName").val(),
      lastName: $("#lastName").val(),
      email: $("#email").val(),
      phoneNumber: $("#phoneNumber").val(),
      role: $("#role").val(),
      physicalAddress: $("#address").val()
    };

    setLoading(true);

    if (editAdmin) {
      updateAdmin(raw, adminId).then((res) => {
        const options = {
          position: "top-right",
        };

        setLoading(false);

        if (res.error) return cogoToast.error("Something went wrong.", options);

        onCloseModal("modalAdmin", "adminForm");
        $("#admins").DataTable().ajax.reload();

        cogoToast.success("Admin successfully Updated.", options);
      });

      return false;
    }

    createAdmin(raw).then((res) => {
      const options = {
        position: "top-right",
      };

      setLoading(false);

      if (res.error) {
        return cogoToast.error(res.payload, options);
      }

      onCloseModal("modalAdmin", "adminForm");
      $("#admins").DataTable().ajax.reload();

      cogoToast.success("Admin successfully Added.", options);
    });
  };

  const onCloseModal = (id, form) => {
    let parsley = $(`#${form}`).parsley();
    $(":input", `#${form}`)
      .not(":button, :submit, :reset, :hidden")
      .val("")
      .prop("checked", false)
      .prop("selected", false);
    $(`#${id}`).modal("hide");
    parsley.reset();
    parsley.destroy();
    $(".modal-backdrop").remove();
  };

  return (
    <div className="content-body">
      <div className="container pd-x-0">
        <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
          <div>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                <li className="breadcrumb-item">
                  <a href="#">Menu</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Admins
                </li>
              </ol>
            </nav>
            <h4 className="mg-b-0 tx-spacing--1">Gari Admins</h4>
          </div>
          <div className="d-none d-md-block">
            <button
              className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5 outline-none"
              onClick={handleShowModal}
            >
              <i className="wd-10 mg-r-5 fa fa-plus"></i> Add New
            </button>
          </div>
        </div>

        <div className="row row-xs">
          <div className="col-md-12 mg-t-10">
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between">
                <h6 className="mg-b-0">Gari Admins</h6>
                <div className="d-flex tx-18">
                  <a
                    href="javascript:void(0)"
                    onClick={() => $("#admins").DataTable().ajax.reload()}
                    className="link-03 lh-0"
                  >
                    <i className="icon ion-md-refresh"></i>
                  </a>
                </div>
              </div>
              <div className="card-body table-responsive">
                <table id="admins" className="table table-hover">
                  <thead>
                    <tr>
                      <th className="wd-20p">Names</th>
                      <th className="wd-20p">Role</th>
                      <th className="wd-20p">Phone Number</th>
                      <th className="wd-20p">Email Address</th>
                      <th className="wd-20p">Actions</th>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="modalAdmin"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered wd-sm-650"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
              <div className="media-body">
                <a
                  href=""
                  role="button"
                  className="close pos-absolute t-15 r-15"
                  data-dismiss="modal"
                  onClick={onCloseModal.bind(null, "modalAdmin", "adminForm")}
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </a>
                <h4 className="tx-18 tx-sm-20 mg-b-2">
                  {editAdmin ? "Edit" : "Add"} Admin
                </h4>
                <p className="tx-13 tx-color-02 mg-b-0">
                  {editAdmin ? "Edit" : "Add"} admin user
                </p>
              </div>
            </div>
            <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
              <form
                id="adminForm"
                className="parsley-style-1"
                onSubmit={onSubmitNewAdmin}
              >
                <div className="row row-sm">
                  <div
                    id="firstNameWrapper"
                    className="form-group parsley-input col-sm-6"
                  >
                    <label>
                      First Name<span className="tx-danger">*</span>
                    </label>
                    <input
                      id="firstName"
                      className="form-control"
                      placeholder="Enter first name"
                      type="text"
                      autoComplete="off"
                      data-parsley-class-handler="#firstNameWrapper"
                      required
                    />
                  </div>

                  <div
                    id="lastNameWrapper"
                    className="form-group parsley-input col-sm-6"
                  >
                    <label>
                      Last Name<span className="tx-danger">*</span>
                    </label>
                    <input
                      id="lastName"
                      className="form-control"
                      placeholder="Enter last name"
                      type="text"
                      autoComplete="off"
                      data-parsley-class-handler="#lastNameWrapper"
                      required
                    />
                  </div>

                  <div
                    id="roleWrapper"
                    className="form-group parsley-input col-sm-12"
                  >
                    <label>
                      Role<span className="tx-danger">*</span>
                    </label>
                    <select className="custom-select" id="role" required>
                      <option value="">Select Role</option>
                      <option value="SupperAdmin">Super Admin</option>
                      <option value="Admin">Admin</option>
                      <option value="Manager">Manager</option>
                      <option value="Support">Support</option>
                    </select>
                  </div>

                  <div
                    id="emailWrapper"
                    className="form-group parsley-input col-sm-6"
                  >
                    <label>
                      Email Address<span className="tx-danger">*</span>
                    </label>
                    <input
                      id="email"
                      className="form-control"
                      placeholder="Enter email address"
                      type="email"
                      autoComplete="off"
                      data-parsley-class-handler="#emailWrapper"
                      required
                    />
                  </div>

                  <div
                    id="phoneWrapper"
                    className="form-group parsley-input col-sm-6"
                  >
                    <label>
                      Phone Number<span className="tx-danger">*</span>
                    </label>
                    <input
                      id="phoneNumber"
                      className="form-control"
                      placeholder="Enter phone number"
                      type="text"
                      autoComplete="off"
                      data-parsley-class-handler="#phoneWrapper"
                      required
                    />
                  </div>

                  <div
                    id="addressWrapper"
                    className="form-group parsley-input col-sm-12"
                  >
                    <label>
                      Physical Address<span className="tx-danger">*</span>
                    </label>
                    <input
                      id="address"
                      className="form-control"
                      placeholder="Enter physical address"
                      type="text"
                      autoComplete="off"
                      data-parsley-class-handler="#addressWrapper"
                      required
                    />
                  </div>
                </div>
                <hr />
                {loading ? (
                  <button disabled className="btn btn-brand-02 btn-block">
                    <span
                      className="spinner-border spinner-border-sm mg-r-10"
                      role="status"
                      aria-hidden="true"
                    />
                    Please Wait
                  </button>
                ) : (
                  <button className="btn btn-brand-01 btnNextFront btn-block">
                    {editAdmin ? "Update" : "Create"}{" "}
                    <i className="ion-md-arrow-forward" />
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Admin;
